import { render } from "./usergroup.vue?vue&type=template&id=5515ef62&scoped=true"
import script from "./usergroup.vue?vue&type=script&lang=js"
export * from "./usergroup.vue?vue&type=script&lang=js"

import "./usergroup.vue?vue&type=style&index=0&id=5515ef62&lang=scss&scoped=true"
import "./usergroup.vue?vue&type=style&index=1&id=5515ef62&lang=scss&scoped=true"

import exportComponent from "/root/workspace/yatinjuryplatformwebcode_Vf1x/CODE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5515ef62"]])

export default __exports__